import React, { useCallback, useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { setConsultSource } from "../lib/consultSource";
import { Button } from "./ui/button";
import { useContent } from "../contexts/ContentContext";
import MobileMenu from "./MobileMenu";

const SCROLL_THRESHOLD_PX = 24;

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Practice Areas", href: "#practice" },
  { label: "Attorneys", href: "#attorneys" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const { firm: FIRM_INFO } = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const onScroll = useCallback(() => setScrolled(window.scrollY > SCROLL_THRESHOLD_PX), []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0c1729] shadow-lg py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between gap-6">
        <a href="#home" className="flex flex-col leading-tight text-white shrink-0">
          <span className="font-serif text-xl md:text-2xl tracking-wide leading-none whitespace-nowrap">Hilty, Bower, Haws &amp; Seable</span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#d4b87a] mt-2">PLLC &middot; Attorneys at Law</span>
        </a>

        <nav className="hidden xl:flex items-center gap-7 2xl:gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link font-serif text-[17px] tracking-wide text-white hover:text-[#d4b87a] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden lg:flex items-center gap-3">
            <Button asChild variant="outline" className="rounded-none px-5 h-10 text-[11px] uppercase tracking-[0.18em] border border-white/40 text-white bg-transparent hover:bg-white hover:text-[#0c1729]">
              <a href="#contact" onClick={() => setConsultSource("Home page — top navigation bar")} data-testid="nav-schedule-consult">Schedule a Consult</a>
            </Button>
            <Button asChild className="rounded-none px-5 h-10 text-[11px] uppercase tracking-[0.18em] bg-[#b8924a] hover:bg-[#a07f3e] text-white border border-[#b8924a]">
              <Link to="/pay" data-testid="nav-pay-online">Pay Online</Link>
            </Button>
          </div>

          <button className="xl:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-menu-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <MobileMenu
          open={open}
          links={LINKS}
          onClose={() => setOpen(false)}
        />
      )}
    </header>
  );
}
